import { render, staticRenderFns } from "./kuaishou_video.vue?vue&type=template&id=1b17f6ec"
import script from "./kuaishou_video.vue?vue&type=script&lang=js"
export * from "./kuaishou_video.vue?vue&type=script&lang=js"
import style0 from "./kuaishou_video.vue?vue&type=style&index=0&id=1b17f6ec&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports